import { defineStore } from 'pinia'
import moment from 'moment-timezone'
import pinia from '@/store.js'

const defaultState = {
	selectedResourceId: null,
	showMap: false,
	timezone: null,
	startTime: null,
	endTime: null
}

export const useScheduleStore = defineStore('schedule', {
	state: () => JSON.parse(localStorage.getItem('schedule')) ?? ({...defaultState}),
	getters: {
		getTimezone() {
			if (!this.timezone) {
				this.timezone = {
					friendlyValue: moment.tz.guess(),
					value: moment.tz.guess()
				}
			}
			return this.timezone
		}
	},
	actions: {

	}
})

useScheduleStore(pinia).$subscribe((mutation, state) => {
    localStorage.setItem('schedule', JSON.stringify(state))
})